import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1d6a33a9"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "account-panel"
};
const _hoisted_2 = {
  class: "panel-header"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "panel-title"
}, "企业账号", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "新增账号", -1));
const _hoisted_5 = {
  class: "panel-search"
};
const _hoisted_6 = {
  class: "panel-list"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["title"];
const _hoisted_9 = {
  key: 0,
  class: "panel-empty"
};
import { createVNode } from 'vue';
import { Modal } from 'ant-design-vue';
import { ExclamationCircleFilled, MoreOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons-vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AccountPanel',
  props: {
    accounts: null,
    keyword: null,
    loading: {
      type: Boolean
    },
    selectedAccountId: null
  },
  emits: ["update:keyword", "select", "add", "delete"],
  setup(__props, {
    emit
  }) {
    const handleAdd = () => emit('add');
    const handleDelete = account => {
      Modal.confirm({
        title: `确认删除账号"${account.accountName}(${account.ssoUserId})"？`,
        icon: createVNode(ExclamationCircleFilled, {
          style: {
            color: '#faad14'
          }
        }),
        content: '删除后，该账号将不再显示，账号下产品信息及历史配置会继续保留。',
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => emit('delete', account.accountId)
      });
    };
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_menu_item = _resolveComponent("a-menu-item");
      const _component_a_menu = _resolveComponent("a-menu");
      const _component_a_dropdown = _resolveComponent("a-dropdown");
      const _component_a_spin = _resolveComponent("a-spin");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_a_button, {
        type: "link",
        class: "add-btn",
        onClick: handleAdd
      }, {
        default: _withCtx(() => [_createVNode(_unref(PlusOutlined)), _hoisted_4]),
        _: 1
      })]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_a_input, {
        value: __props.keyword,
        placeholder: "输入账号名称/ID",
        "allow-clear": "",
        "onUpdate:value": _cache[0] || (_cache[0] = val => emit('update:keyword', val !== null && val !== void 0 ? val : ''))
      }, {
        suffix: _withCtx(() => [_createVNode(_unref(SearchOutlined), {
          class: "search-icon"
        })]),
        _: 1
      }, 8, ["value"])]), _createVNode(_component_a_spin, {
        spinning: __props.loading,
        "wrapper-class-name": "panel-spin"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.accounts, item => {
          return _openBlock(), _createElementBlock("div", {
            key: item.accountId,
            class: _normalizeClass(["account-item", {
              active: item.accountId === __props.selectedAccountId
            }]),
            onClick: $event => emit('select', item.accountId)
          }, [_createElementVNode("span", {
            class: "account-name",
            title: `${item.accountName}(${item.ssoUserId})`
          }, _toDisplayString(item.accountName) + "(" + _toDisplayString(item.ssoUserId) + ") ", 9, _hoisted_8), _createVNode(_component_a_dropdown, {
            trigger: ['click'],
            placement: "bottomRight"
          }, {
            overlay: _withCtx(() => [_createVNode(_component_a_menu, {
              onClick: () => handleDelete(item)
            }, {
              default: _withCtx(() => [_createVNode(_component_a_menu_item, {
                key: "delete"
              }, {
                default: _withCtx(() => [_createTextVNode("删除")]),
                _: 1
              })]),
              _: 2
            }, 1032, ["onClick"])]),
            default: _withCtx(() => [_createElementVNode("span", {
              class: "more-btn",
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
            }, [_createVNode(_unref(MoreOutlined))])]),
            _: 2
          }, 1024)], 10, _hoisted_7);
        }), 128)), !__props.loading && !__props.accounts.length ? (_openBlock(), _createElementBlock("div", _hoisted_9, "没有匹配的账号")) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["spinning"])]);
    };
  }
});